import * as React from 'react';
import get from 'lodash/get';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { useRecordContext } from 'ra-core';

import {sanitizeFieldRestProps} from 'react-admin';

const useStyles = makeStyles(
    {
        chip: { margin: 4, cursor: 'inherit' },
    },
    { name: 'RaChipField' }
);

export const ChipField = (props => {
    const {
        className,
        classes: classesOverride,
        source,
        emptyText,
        ...rest
    } = props;
    const record = useRecordContext(props);
    const classes = useStyles(props);
    const value = get(record, source);

    return (
        <Chip
            className={classnames(classes.chip, className)}
            label={value.toLowerCase()}
            {...sanitizeFieldRestProps(rest)}
        />
    );
});

export default ChipField;
